import type { InventoryVehicle } from '@carvana/merch-contracts';
import { VDP_LINK_COUNT } from '~/constants/home';
import { VDPLinkTitles } from '~/constants/home/VdpLinkTitles';

type VdpLinks<TVehicle = InventoryVehicle> = {
  header: VDPLinkTitles;
  showLink: boolean;
  vehicles: Array<TVehicle>;
};

// Favorites win, then recently viewed, then suggested; null when there is nothing to show.
export default function selectVdpLinks<TVehicle>({
  favorites,
  recent,
  suggested
}: {
  favorites: Array<TVehicle>;
  recent: Array<TVehicle>;
  suggested: Array<TVehicle>;
}): VdpLinks<TVehicle> | null {
  if (favorites.length > 0) {
    return {
      header: VDPLinkTitles.Favorite,
      showLink: favorites.length > VDP_LINK_COUNT,
      vehicles: favorites.slice(0, VDP_LINK_COUNT)
    };
  }

  if (recent.length > 0) {
    return {
      header: VDPLinkTitles.Recent,
      showLink: false,
      vehicles: recent.slice(0, VDP_LINK_COUNT)
    };
  }

  if (suggested.length > 0) {
    return {
      header: VDPLinkTitles.Suggested,
      showLink: false,
      vehicles: suggested.slice(0, VDP_LINK_COUNT)
    };
  }

  return null;
}
